import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { ToggleSection, Box } = designSystem;

const Toggle = ({ isToggleEnabled = false, title, popover = null, handleChange = () => {} }) => (
  <Box
    paddingTop="spacing-xs"
    paddingBottom="spacing-xs"
    paddingLeft="spacing-m"
    paddingRight="spacing-m"
  >
    <ToggleSection
      value={isToggleEnabled}
      title={title}
      {...(popover && { popoverProps: popover })}
      onChange={handleChange}
    />
  </Box>
);

Toggle.propTypes = {
  isToggleEnabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  popover: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imgSrc: PropTypes.string,
  }),
  handleChange: PropTypes.func,
};

export default Toggle;
